module.exports = __webpack_public_path__ + "static/media/ME_Logo.21c907ac.jpg";